export enum AuthorizationType {
    EMAIL_NOTIFICATIONS = 5,
    DATA_PROCESSING = 6,
    SENSITIVE_DATA = 2,
    TERMS = 1,
    STUDY_PLAN = 7,
    IS_MINOR = 8,
    ECONOMIC_ACTIVITY = 3,
    ECONOMIC_ACTIVITY_SECONDARY = 4
}

export interface Authorization {
    id: number
    idAspirant: number
    idInscription: null | number
    authorizationType: AuthorizationType
    isAccepted: boolean
    acceptedAt: string
    revokedAt: null | string
    valueText: null | string
    updatedBy: number
}
